import React from 'react';

const Projects = React.forwardRef((props, ref) => (
  <section 
    id="projects" 
    ref={ref} 
    data-animate
    className="min-h-screen bg-gradient-to-b from-white to-gray-50 py-20 px-8"
  >
    <div className="container mx-auto">
      <h2 className="text-4xl font-bold mb-16 text-center text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600">
        Featured Projects
      </h2>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
        <div className="project-card bg-white rounded-2xl shadow-xl overflow-hidden transition-all duration-300 hover:shadow-2xl hover:-translate-y-2">
          <div className="h-48 bg-gradient-to-r from-blue-500 to-purple-600 flex items-center justify-center text-white text-xl font-bold">
            OSB Websites
          </div>
          <div className="p-6">
            <h3 className="text-2xl font-bold mb-2 text-gray-800">Marketing Websites</h3>
            <p className="text-gray-600 mb-4">Developed high-performance marketing websites using Umbraco and .NET</p>
            <div className="flex flex-wrap gap-2 mb-4">
              <span className="px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm">Umbraco</span>
              <span className="px-3 py-1 bg-purple-100 text-purple-800 rounded-full text-sm">.NET</span>
              <span className="px-3 py-1 bg-green-100 text-green-800 rounded-full text-sm">TeamCity</span>
            </div>
            <a href="https://www.linkedin.com/in/joseph-d-a17664151/" target="_blank" rel="noopener noreferrer" className="block w-full mt-4 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-center rounded-lg transition-colors">
              View on LinkedIn
            </a>
          </div>
        </div>

        <div className="project-card bg-white rounded-2xl shadow-xl overflow-hidden transition-all duration-300 hover:shadow-2xl hover:-translate-y-2">
          <div className="h-48 bg-gradient-to-r from-orange-500 to-pink-600 flex items-center justify-center text-white text-xl font-bold">
            GanttGenAI
          </div>
          <div className="p-6">
            <h3 className="text-2xl font-bold mb-2 text-gray-800">AI Project Planner</h3>
            <p className="text-gray-600 mb-4">Next.js app with AI-generated Gantt charts using Vercel and Supabase</p>
            <div className="flex flex-wrap gap-2 mb-4">
              <span className="px-3 py-1 bg-orange-100 text-orange-800 rounded-full text-sm">Next.js</span>
              <span className="px-3 py-1 bg-pink-100 text-pink-800 rounded-full text-sm">AI</span>
              <span className="px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm">Supabase</span>
            </div>
            <a href="https://www.ganttgenai.co.uk" target="_blank" rel="noopener noreferrer" className="block w-full mt-4 px-4 py-2 bg-orange-600 hover:bg-orange-700 text-white text-center rounded-lg transition-colors">
              Visit Website
            </a>
          </div>
        </div>

        <div className="project-card bg-white rounded-2xl shadow-xl overflow-hidden transition-all duration-300 hover:shadow-2xl hover:-translate-y-2">
          <div className="h-48 bg-gradient-to-r from-indigo-500 to-blue-600 flex items-center justify-center text-white text-xl font-bold">
            GlitchBot
          </div>
          <div className="p-6">
            <h3 className="text-2xl font-bold mb-2 text-gray-800">AI Chat Assistant</h3>
            <p className="text-gray-600 mb-4">React chatbot with OpenAI integration deployed on Azure</p>
            <div className="flex flex-wrap gap-2 mb-4">
              <span className="px-3 py-1 bg-indigo-100 text-indigo-800 rounded-full text-sm">React</span>
              <span className="px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm">OpenAI</span>
              <span className="px-3 py-1 bg-gray-100 text-gray-800 rounded-full text-sm">Azure</span>
            </div>
            <a href="https://glitchbot.co.uk" target="_blank" rel="noopener noreferrer" className="block w-full mt-4 px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white text-center rounded-lg transition-colors">
              Visit Website
            </a>
          </div>
        </div>

        <div className="project-card bg-white rounded-2xl shadow-xl overflow-hidden transition-all duration-300 hover:shadow-2xl hover:-translate-y-2">
          <div className="h-48 bg-gradient-to-r from-green-600 to-emerald-500 flex items-center justify-center text-white text-xl font-bold">
            CyberHeroes
          </div>
          <div className="p-6">
            <h3 className="text-2xl font-bold mb-2 text-gray-800">Security Education</h3>
            <p className="text-gray-600 mb-4">WordPress content site for cybersecurity education</p>
            <div className="flex flex-wrap gap-2 mb-4">
              <span className="px-3 py-1 bg-green-100 text-green-800 rounded-full text-sm">WordPress</span>
              <span className="px-3 py-1 bg-emerald-100 text-emerald-800 rounded-full text-sm">Security</span>
              <span className="px-3 py-1 bg-yellow-100 text-yellow-800 rounded-full text-sm">Content</span>
            </div>
            <a href="https://cyberheroes.co.uk" target="_blank" rel="noopener noreferrer" className="block w-full mt-4 px-4 py-2 bg-green-600 hover:bg-green-700 text-white text-center rounded-lg transition-colors">
              Visit Website
            </a>
          </div>
        </div>

        <div className="project-card bg-white rounded-2xl shadow-xl overflow-hidden transition-all duration-300 hover:shadow-2xl hover:-translate-y-2">
          <div className="h-48 bg-gradient-to-r from-green-500 to-teal-600 flex items-center justify-center text-white text-xl font-bold">
            Freelance Projects
          </div>
          <div className="p-6">
            <h3 className="text-2xl font-bold mb-2 text-gray-800">Client Websites</h3>
            <p className="text-gray-600 mb-4">Built responsive websites with React, NodeJS and various CMS platforms</p>
            <div className="flex flex-wrap gap-2 mb-4">
              <span className="px-3 py-1 bg-cyan-100 text-cyan-800 rounded-full text-sm">React</span>
              <span className="px-3 py-1 bg-indigo-100 text-indigo-800 rounded-full text-sm">NodeJS</span>
              <span className="px-3 py-1 bg-red-100 text-red-800 rounded-full text-sm">SEO</span>
            </div>
            <a href="https://github.com/joedrozd" target="_blank" rel="noopener noreferrer" className="block w-full mt-4 px-4 py-2 bg-cyan-600 hover:bg-cyan-700 text-white text-center rounded-lg transition-colors">
              View on GitHub
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
));

export default Projects;
